import React from "react";

import { RouteConfig } from "../Router";
import { PermissionType } from "amnShared/Permissions/IPermissions";

const StatisticsPage = React.lazy(
  () => import("amnShared/clinetAction/statistics/StatisticsPage"),
);
const DeliveryOrdersPage = React.lazy(
  () => import("amnShared/clinetAction/delivery/DeliveryOrdersPage"),
);
const PickupOrdersPage = React.lazy(
  () => import("amnShared/clinetAction/pickup/PickupOrdersPage"),
);
const UserProfile = React.lazy(() => import("amnShared/user/UserProfile"));
const FinishedTransaction = React.lazy(
  () => import("amnPos/action/finishedTransactions/FinishedTransaction"),
);
const TransactionDetails = React.lazy(
  () =>
    import(
      "amnPos/action/finishedTransactions/TransactionDetails/TransactionDetails"
    ),
);
const ShiftSummaryPOSPage = React.lazy(
  () => import("amnPos/FrontEndReports/ShiftSummary/ShiftSummaryPage"),
);
const CalculatedCashDetailsPOSPage = React.lazy(
  () =>
    import(
      "amnPos/FrontEndReports/CalculatedCashDetails/CalculatedCashDetailsPage"
    ),
);
const CalculatedNonCashDetailsPOSPage = React.lazy(
  () =>
    import(
      "amnPos/FrontEndReports/CalculatedNonCashDetails/CalculatedNonCashDetails"
    ),
);
const MaterialsTransactionDetailsPOSPage = React.lazy(
  () =>
    import(
      "amnPos/FrontEndReports/MaterialsTransactionDetails/MaterialsTransactionDetailsPage"
    ),
);
const ExternalTransactionDetailsPOSPage = React.lazy(
  () =>
    import(
      "amnPos/FrontEndReports/ExternalTransactionDetails/ExternalTransactionDetailsPage"
    ),
);
const ShiftClosingDetailsPOSPage = React.lazy(
  () =>
    import(
      "amnPos/FrontEndReports/ShiftClosingDetails/ShiftClosingDetailsPage"
    ),
);
const FinishedOrdersDetails = React.lazy(
  () =>
    import(
      "amnPos/action/finishedOrders/fnishedOrderDetails/FinishedOrdersDetails"
    ),
);
const PosMainPage = React.lazy(() => import("amnPos/pages/PosMainPage"));
const DeliverPickUpOrderPage = React.lazy(
  () => import("amnPos/pages/DeliverPickUpOrderPage/DeliverPickUpOrderPage"),
);
const CustomerStatementPosReport = React.lazy(
  () => import("amnPos/FrontEndReports/CustomerStatementPosReport"),
);
const EditClientPage = React.lazy(
  () => import("amnShared/clients/EditClientPage"),
);
const SettleDeliveryPaymentsPage = React.lazy(
  () =>
    import(
      "amnShared/DriverManagement/SettleDeliveryPaymentsPage/SettleDeliveryPaymentsPage"
    ),
);
const MaterialsTransactions = React.lazy(
  () => import("amnPos/materialsTransaction/MaterialsTransactions"),
);
const ShiftsAndExternalsPage = React.lazy(
  () => import("amnPos/shiftsAndExternals/ShiftsAndExternalsPage"),
);
const OrderManagementPage = React.lazy(
  () => import("amnShared/orderManagement/OrderManagementPage"),
);
const DriverManagementPage = React.lazy(
  () =>
    import(
      "amnShared/DriverManagement/DriverManagementPage/DriverManagementPage"
    ),
);
const DeliveryTripSettlementPage = React.lazy(
  () =>
    import(
      "amnShared/DriverManagement/DeliveryTripSettlementPage/DeliveryTripSettlementPage"
    ),
);
const DeliveryStartTripPassingDriverPage = React.lazy(
  () =>
    import(
      "amnShared/DriverManagement/DeliveryStartTripPassingDriverPage/DeliveryStartTripPassingDriverPage"
    ),
);
const DriverReport = React.lazy(
  () => import("amnShared/Reports/DriverReport/DriverReport"),
);
const TripDetailsReport = React.lazy(
  () => import("amnShared/Reports/TripDetailsReport/TripDetailsReport"),
);
const OtherInformationspage = React.lazy(
  () =>
    import(
      "amnShared/orderManagement/ordersEventHistory/OrderEventHistoryPage"
    ),
);

const TicketSection = React.lazy(
  () => import("amnPos/materialsTransaction/ticketArea/TicketSection"),
);

const ConfigurationPage = React.lazy(
  () => import("amnPos/configuration/ConfigurationPage"),
);

const PosClientsListPage = React.lazy(
  () => import("amnPos/action/client/PosClientsListPage"),
);
const TicketPayment = React.lazy(
  () => import("amnPos/ticket/payment/TicketPayment"),
);
const FinishedOrders = React.lazy(
  () => import("amnPos/action/finishedOrders/FinishedOrders"),
);

const posRoutes = (helpers: {
  getPath: any;
  LoggedInPos: any;
  getClientPagePermissions: any;
  RouterNavigateType: any;
}): RouteConfig => ({
  path: helpers.getPath("/pos"),
  element: helpers.LoggedInPos(<PosMainPage />),
  children: [
    { path: "", element: helpers.LoggedInPos(<MaterialsTransactions />) },
    {
      path: helpers.getPath("/pos/materialsTransactions"),
      element: helpers.LoggedInPos(<MaterialsTransactions />),
    },
    {
      path: helpers.getPath("/pos/materialsTransactions/finished"),
      element: helpers.LoggedInPos(<FinishedTransaction />),
    },
    {
      path: helpers.getPath("/pos/materialsTransactions/finished/:id"),
      element: helpers.LoggedInPos(<TransactionDetails />),
    },
    {
      path: helpers.getPath("/pos/shiftSummary/:id"),
      element: helpers.LoggedInPos(
        <ShiftSummaryPOSPage />,
        PermissionType.CanViewShiftDigest,
      ),
    },
    {
      path: helpers.getPath("/pos/calculatedCashDetails/:id"),
      element: helpers.LoggedInPos(
        <CalculatedCashDetailsPOSPage />,
        PermissionType.CanViewCalculatedCashDetails,
      ),
    },
    {
      path: helpers.getPath("/pos/calculatedNonCashDetails/:id"),
      element: helpers.LoggedInPos(
        <CalculatedNonCashDetailsPOSPage />,
        PermissionType.CanViewCalculatedNonCashDetails,
      ),
    },
    {
      path: helpers.getPath("/pos/materialsTransactionDetails/:id"),
      element: helpers.LoggedInPos(
        <MaterialsTransactionDetailsPOSPage />,
        PermissionType.CanViewMaterialsAndServicesTransactionsDetail,
      ),
    },
    {
      path: helpers.getPath("/pos/externalTransactionDetails/:id"),
      element: helpers.LoggedInPos(
        <ExternalTransactionDetailsPOSPage />,
        PermissionType.CanViewExternalTransactionsDetails,
      ),
    },
    {
      path: helpers.getPath("/pos/shiftClosingDetails/:id"),
      element: helpers.LoggedInPos(
        <ShiftClosingDetailsPOSPage />,
        PermissionType.CanViewClosingDetails,
      ),
    },
    {
      path: helpers.getPath("/pos/customer-statement-report/:id"),
      element: helpers.LoggedInPos(
        <CustomerStatementPosReport />,
        PermissionType.CanViewCustomerBalanceStatement,
      ),
    },
    {
      path: helpers.getPath("/pos/specialOffers"),
      element: helpers.LoggedInPos(<>Special Offers</>),
    },
    {
      path: helpers.getPath("/pos/shiftsAndExternals"),
      element: helpers.LoggedInPos(<ShiftsAndExternalsPage />),
    },
    {
      path: helpers.getPath("/pos/OrderManagement"),
      element: helpers.LoggedInPos(
        <OrderManagementPage />,
        PermissionType.CanUseOrderManagementTab,
      ),
    },
    {
      path: helpers.getPath("/pos/driverManagementPage"),
      element: helpers.LoggedInPos(
        <DriverManagementPage />,
        PermissionType.CanUseDeliveryOrdersManagement,
      ),
    },
    {
      path: helpers.getPath("/pos/deliveryTripSettlementPage/:id"),
      element: helpers.LoggedInPos(
        <DeliveryTripSettlementPage />,
        PermissionType.CanSettleDeliveryTrip,
      ),
    },
    {
      path: helpers.getPath("/pos/deliveryStartTripPassingDriverPage/:id"),
      element: helpers.LoggedInPos(<DeliveryStartTripPassingDriverPage />),
    },
    {
      path: helpers.getPath("/pos/driverReport/:id"),
      element: helpers.LoggedInPos(<DriverReport />),
    },
    {
      path: helpers.getPath("/pos/tripDetailsReport/:id"),
      element: helpers.LoggedInPos(<TripDetailsReport />),
    },
    {
      path: helpers.getPath("/pos/settleDeliveryPaymentsPage"),
      element: helpers.LoggedInPos(<SettleDeliveryPaymentsPage />),
    },
    {
      path: helpers.getPath(
        "/pos/OrderManagement/OrdersEventHistory/:id/:delivery",
      ),
      element: helpers.LoggedInPos(<OtherInformationspage />),
    },
    {
      path: helpers.getPath("/pos/settings"),
      element: helpers.LoggedInPos(<>Settings</>),
    },
    {
      path: helpers.getPath("/pos/materials"),
      element: helpers.LoggedInPos(<TicketSection pathname="" />),
    },
    {
      path: helpers.getPath("/pos/posDrawer"),
      element: helpers.LoggedInPos(<ConfigurationPage />),
    },
    {
      path: helpers.getPath("/pos/deliverPickUpOrderPage/:id"),
      element: helpers.LoggedInPos(
        <DeliverPickUpOrderPage />,
        PermissionType.CanSettlePickupOrder,
      ),
    },
    {
      path: helpers.getPath("/pos/clientsList/:id"),
      element: helpers.LoggedInPos(<PosClientsListPage />),
    },
    {
      path: helpers.getPath("/pos/create-client"),
      element: helpers.LoggedInPos(
        <EditClientPage
          navigateTo={helpers.RouterNavigateType.Pos}
          permissions={helpers.getClientPagePermissions()}
        />,
        PermissionType.CanAddNewClient,
      ),
    },
    {
      path: helpers.getPath("/pos/edit-client/:id"),
      element: helpers.LoggedInPos(
        <EditClientPage
          navigateTo={helpers.RouterNavigateType.Pos}
          permissions={helpers.getClientPagePermissions()}
        />,
        PermissionType.CanModifyExistingClient,
      ),
    },
    {
      path: helpers.getPath("/pos/statistics-client/:id"),
      element: helpers.LoggedInPos(<StatisticsPage />),
    },
    {
      path: helpers.getPath("/pos/delivery-client/:id"),
      element: helpers.LoggedInPos(<DeliveryOrdersPage />),
    },
    {
      path: helpers.getPath("/pos/pickup-client/:id"),
      element: helpers.LoggedInPos(<PickupOrdersPage />),
    },
    {
      path: helpers.getPath("/pos/ticket-payment"),
      element: helpers.LoggedInPos(<TicketPayment />),
    },
    {
      path: helpers.getPath("/pos/user-profile"),
      element: helpers.LoggedInPos(
        <UserProfile navigateTo={helpers.RouterNavigateType.Pos} />,
      ),
    },
    {
      path: helpers.getPath("/pos/finished-orders"),
      element: helpers.LoggedInPos(<FinishedOrders />),
    },
    {
      path: helpers.getPath("/pos/finished-orders/:id"),
      element: helpers.LoggedInPos(<FinishedOrdersDetails />),
    },
    { path: "*", element: <div>Invalid route</div> },
  ],
});

export default posRoutes;
